// markDisturbingAction.js
'use strict';
import toggleDisturbing from '../action/toggleDisturbing.js';
import { mark } from '../resource/disturbing.js';

/**
 * mark and execute disturbing action
 * @kind action
 * @param {object} args
 * @param {'enable'|'disable'} args.action
 * @return {Promise} Action promise.
 */
const markDisturbingAction =
  ({ action }) =>
  async dispatch => {
    if (!['enable', 'disable'].includes(action))
      throw new Error("`action` must be one of 'enable' and 'disable'");

    const shouldDisturb = action === 'enable';

    return Promise.all([
      mark({ shouldDisturb }),
      dispatch(toggleDisturbing({ shouldDisturb })),
    ]);
  };

export default markDisturbingAction;
